import React from 'react'
import TableCompareSync from '../TableCompareSync/TableCompareSync'

const PreviewSync = ({ detail }) => {

  return (
    <TableCompareSync
      changes={detail.change}
    />
  )
}

export default PreviewSync